import { axiosReqCardClient, axiosReqCardClient60s } from '../plugins/axios'
import { axiosHrClient } from '../plugins/axios'

const leave = {
  namespaced: true,

  actions: {
    getSystemMenusAdmin() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            '/hrportal/self/catelogroles/121/programitemroles'
          )
          let list_obj = {}
          res.data.data.forEach(item => {
            if (!Array.isArray(list_obj[item.programCatelogFullNameTha]))
              list_obj[item.programCatelogFullNameTha] = []
            list_obj[item.programCatelogFullNameTha].push({
              name: item.programItemFullNameTha,
              programItemMenuID: item.programItemMenuID,
              itemPath: item.programItemPath,
              otherSystem: item.otherSystem
            })
          })
          const list = []
          for (let key in list_obj) {
            list.push({
              title: key,
              menus: list_obj[key]
            })
          }
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },
    getSystemMenus(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrportal/employees/${guid}/menusystems/3/programcatelogs/121`
          )
          const list = res.data.data.map(item => {
            const obj = {}
            obj.title = item.menuInSystemFullNameTha
            obj.menus = item.data.map(subItem => {
              return {
                name: subItem.menuInSystemFullNameTha,
                programItemMenuID: subItem.programItemMenuID,
                itemPath: subItem.menuInSystemPath,
                otherSystem: subItem.otherSystem
              }
            })
            return obj
          })
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },
    getInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.get(
            `/employees/self/requestinfoByEmId`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getRequestedList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient60s.get(
            `/CardInfo/CardHistoryInfo/EmId/${payload.guid}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getInfoByCardcode(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.get(
            `/CardInfo/CardCode/${payload}`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getStatusByCardcode(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.get(
            `/CardInfo/CardCode/${payload}/check`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    addNewRequest(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/CardInfo/uploadFullInfo`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    updateCard(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.put(`/cardhrcode/`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    editRequest(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.put(
            `/CardInfo/Updatecardfrom/CardCode`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    editOldEmpRequest(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.put(
            `/AdminReqOldEmp/Info`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    setReqCardStatus(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.put(
            `/CardInfo/UpdateCardStatus/CardCode`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    deleteReqCard(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.put(
            `/CardInfo/Cancelcard/CardCode`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getOldEmpInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.get(`/AdminReqOldEmp/Info`, {
            headers: {
              personalid: payload
            }
          })
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postOldEmpInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/AdminReqOldEmp/Info`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    adminSearch(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/CardInfo/AdminSearchCard`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    superAdminSetEdit(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.put(
            `/CardInfo/EditAbleStatus/CardCode`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getExcelDataForHr(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/CardInfo/report/ExcleForHr`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getExcelDataForFND(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/CardInfo/report/ExcleForFND`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getExcelFileForHr(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/CardInfo/file/ExcleForHr`,
            payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getExcelFileForFND(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(
            `/CardInfo/file/ExcleForFND`,
            payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getReceipt(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.get(
            `/CardInfo/self/downloadrecipe/` + payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getFile(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.get(
            `/CardInfo/self/download/` + payload,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    sendEmail(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCardClient.post(`/SendEmail`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default leave
